import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { VivaInsightsLinkedService } from 'app/model/linkedservice/viva-insights.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'VivaInsightsReport',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.VivaInsights_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.VivaInsights_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: VivaInsightsLinkedService.MODEL
        }
    }
})
export class VivaInsightsReportDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
